import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const CheckboxFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath, label }) => {
  const { control } = useFormContext();
  return (
    <FormControlLabel
      control={
        <Controller
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}`}
          control={control}
          render={({ field: props }) => (
            <Checkbox
              {...props}
              checked={props.value}
              onChange={(e) => props.onChange(e.target.checked)}
            />
          )}
        />
      }
      label={label}
    />
  );
};

export default CheckboxFormFields;
